var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import _ from 'underscore';

var CommonCoveragesCtrl = function () {
    _createClass(CommonCoveragesCtrl, null, [{
        key: '$inject',
        get: function get() {
            return ['StateUtils', 'CoveragesUtil', 'ModalService', '$filter'];
        }
    }]);

    function CommonCoveragesCtrl(StateUtils, CoveragesUtil, ModalService, $filter) {
        _classCallCheck(this, CommonCoveragesCtrl);

        this.StateUtils = StateUtils;
        this.CoveragesUtil = CoveragesUtil;
        this.ModalService = ModalService;
        this.$filter = $filter;
    }

    _createClass(CommonCoveragesCtrl, [{
        key: '$onInit',
        value: function $onInit() {
            this.model = this.StateUtils.activeDataForState(true).model;
            this.coverages = this.model.lobData.businessOwners.coverages;
            this.dependentCoverages = this.CoveragesUtil.getDependentCoverages();

            this.coverageFilter = '';
            this.prevResult = '';

            this.nextStep = this.nextStep.bind(this);
            this.onCovChange = this.onCovChange.bind(this);
        }
    }, {
        key: 'showError',
        value: function showError() {
            this.ModalService.showError('gw-portals-bop-components-angular.coverages.common.commonCoveragesCtrl.Error', 'gw-portals-bop-components-angular.coverages.common.commonCoveragesCtrl.An error has occurred...');
        }
    }, {
        key: 'onCovChange',
        value: function onCovChange(coverage) {
            var _this = this;

            var lobCoverages = _.mapObject(this.model.lobData, function (lob) {
                return lob.coverages ? lob.coverages.value : undefined;
            });

            var jobID = this.model.quoteID ? this.model.quoteID.value : this.model.jobID.value;
            var sessionUUID = this.model.sessionUUID ? this.model.sessionUUID.value : undefined;
            var sequencer = this.CoveragesUtil.getSequencer();
            var operation = sequencer(this.updateCoverages(jobID, lobCoverages, sessionUUID));
            this.coveragesLoading = true;

            return operation.then(function (result) {
                var coverages = result.businessOwners ? result.businessOwners : result.lobData.businessOwners.coverages;
                _this.setCoverages(coverage, coverages); // This function should be override by a additional/general coverages subclass
            }).catch(this.showError).finally(function () {
                _this.coveragesLoading = false;
            });
        }
    }, {
        key: 'nextStep',
        value: function nextStep(callback, form) {
            var _this2 = this;

            if (this.CoveragesUtil.validateForm(form)) {
                this.onCovChange().then(function () {
                    return callback(_this2.model);
                }, function () {
                    callback();
                }).catch(this.showError);
            } else {
                callback();
            }
        }
    }, {
        key: 'filteredCoverages',
        value: function filteredCoverages() {
            var result = this.$filter('filter')(this.coverages.value.additionalCoverages, { name: this.coverageFilter });
            if (_.isEqual(this.prevResult, result)) {
                return this.prevResult;
            }

            this.prevResult = result;
            return result;
        }
    }]);

    return CommonCoveragesCtrl;
}();

export default CommonCoveragesCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-bop-components-angular/coverages/common/coveragesCtrl.js
// module id = 339
// module chunks = 0